<template>
  <div>
    <div class="course-result-table mt-3">
      <!-- ローディング -->
      <div class="text-center">
        <v-progress-circular v-if="isViewLoading" indeterminate color="secondary" />
      </div>

      <!-- キャンペーン終了まであと◯日（SP） -->
      <div
        v-if="isMobile"
        class="pb-6"
      >
        <v-card
          elevation="0"
          class=""
        >
          <div v-if="!isContinuity && isCampaignStarted">
            <!-- 通常版 かつ キャンペーン終了前 -->
            <div v-if="remainingDaysByNomalCampaignEnd > 0" class="course-result-table__rest font-weight-bold text-center">
              キャンペーン終了まで あと<span class="c-result-text-color--blue is-days-rest c-result-font-roboto--500">{{ remainingDaysByNomalCampaignEnd }}</span>日
            </div>
            <!-- 通常版 かつ 通常版サイトクローズ前 -->
            <div v-else-if="remainingDaysByNomalSiteClose > 0" class="course-result-table__rest font-weight-bold text-center">
              通常版入力締切まで あと<span class="c-result-text-color--blue is-days-rest c-result-font-roboto--500">{{ remainingDaysByNomalSiteClose }}</span>日
            </div>
            <!-- 通常版のサイトクローズ後 -->
            <div v-else-if="remainingDaysByContinueSiteClose > 0" class="course-result-table__rest font-weight-bold text-center">
              サイトクローズまで あと<span class="c-result-text-color--blue is-days-rest c-result-font-roboto--500">{{ remainingDaysByContinueSiteClose }}</span>日
            </div>
          </div>
          <!-- 継続版 -->
          <div v-else>
            <div class="course-result-table__rest font-weight-bold text-center">
              サイトクローズまで あと<span class="c-result-text-color--blue is-days-rest c-result-font-roboto--500">{{ remainingDaysByContinueSiteClose }}</span>日
            </div>
          </div>
        </v-card>
      </div>

      <!-- 達成状況確認 -->
      <ul :class="listClass">
        <li
          v-for="(course) in courseResultList" :key="course.id"
          class="course-result-table__col"
        >
          <v-card outlined>
            <div class="c-result-font-roboto--500 c-result-dialog-card confirm-dates">
              <v-row
                no-gutters
                class="justify-space-between"
              >
                <v-col
                  cols="5"
                  class=""
                >
                  <div class="confirm-dates-days">
                    <svg viewBox='0 0 36 36'>
                      <!-- グラデーション指定 -->
                      <defs>
                        <linearGradient id="svg_config_gradient02" x1="1" x2="0" y1="0" y2="0">
                          <stop offset="0%" stop-color="#73D0FF" />
                          <stop offset="100%" stop-color="#139BDF" />
                        </linearGradient>
                      </defs>
                      <!-- 円グラフ -->
                      <circle cx='18' cy='18' r='15.5' fill='none' stroke='#EAF6F7' stroke-width='5' />
                      <circle v-if="calculateClearRate(course) > 0" cx='18' cy='18' r='15.5' fill='none' stroke='url(#svg_config_gradient02)' stroke-width='5'
                        :stroke-dasharray="`${calculateClearRate(course)}, ${calculateRemainingClearRate(course)}`" stroke-linecap='round' transform='rotate(-90 18 18)' />
                    </svg>
                    <div v-if="course.complete_type === 'Daily_CircleAndCross' || course.complete_type === 'Daily_StandardValue'" class="confirm-dates-days__text text-center">
                      <span class="is-days-now">{{ course.aggregate_result_info.clear_count }}</span>日<br>クリア
                    </div>
                    <div v-if="course.complete_type === 'UpperLimit'" class="confirm-dates-days__text text-center">
                      <span class="is-days-now">{{ course.aggregate_result_info.clear_count }}</span>回<br>クリア
                    </div>
                    <div v-if="course.complete_type === 'Weekly_CircleAndCross'" class="confirm-dates-days__text text-center">
                      <span class="is-days-now">{{ course.aggregate_result_info.clear_count }}</span>週<br>クリア
                    </div>
                    <p v-if="course.aggregate_result_info.is_completed" class="is-clear ma-0">
                      <img src="/image/badge/clear.png" alt="達成">
                    </p>
                  </div>
                </v-col>
                <v-col
                  cols="7"
                  class="confirm-dates__col--details"
                >
                  <p class="confirm-dates__title ma-0 font-weight-bold">{{ course.name }}</p>
                  <table class="confirm-dates__table c-custom--w-100">
                    <tr>
                      <th class="text-left">ポイント</th>
                      <td class="text-right"><span>{{ course.point }}</span>pt</td>
                    </tr>
                    <tr v-if="course.aggregate_result_info.average !== null">
                      <th class="text-left">平均</th>
                      <td class="text-right"><span>{{ course.aggregate_result_info.average.toLocaleString() }}</span>{{ course.unit }}</td>
                    </tr>
                    <tr v-if="course.aggregate_result_info.total !== null">
                      <th class="text-left">累計</th>
                      <td class="text-right"><span>{{ course.aggregate_result_info.total.toLocaleString() }}</span>{{ course.unit }}</td>
                    </tr>
                  </table>
                  <div class="pt-4 text-right">
                    <v-btn
                      @click="openModal(course)"
                      rounded
                      class="c-result-btn--gray c-result-btn--gray--modal confirm-dates-result-btn--gray font-weight-bold"
                    >
                      コース説明
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <v-row
                no-gutters
                class="justify-space-between"
              >
                <v-col v-for="dataSet in chartDataSetList" :key="dataSet.courseId" cols="12" width="100%" class="confirm-dates-graph mt-4">
                  <line-chart v-if="dataSet.courseId === course.id" :chartData="dataSet.chartData" :options="dataSet.options" :styles="chartStyle" :height="200"></line-chart>
                </v-col>
              </v-row>
              <div v-if="!course.aggregate_result_info.is_completed">
                <div v-if="course.complete_type === 'Daily_CircleAndCross' || course.complete_type === 'Daily_StandardValue'" class="confirm-dates-rest d-flex justify-center align-center mt-4 py-2 font-weight-bold">
                  達成に必要なクリア日数は<span class="d-flex">あと<span class="c-result-text-color--blue is-days-rest">{{ course.required_clear }}</span>日</span>
                </div>
                <div v-if="course.complete_type === 'UpperLimit'" class="confirm-dates-rest d-flex justify-center align-center mt-4 py-2 font-weight-bold">
                  達成に必要なクリア回数は<span class="d-flex">あと<span class="c-result-text-color--blue is-days-rest">{{ course.required_clear }}</span>回</span>
                </div>
                <div v-if="course.complete_type === 'Weekly_CircleAndCross'" class="confirm-dates-rest d-flex justify-center align-center mt-4 py-2 font-weight-bold">
                  達成に必要なクリア週数は<span class="d-flex">あと<span class="c-result-text-color--blue is-days-rest">{{ course.required_clear }}</span>週</span>
                </div>
              </div>
            </div>
          </v-card>
        </li>

        <!-- その他獲得ポイント -->
        <li
          v-if="campaign.is_continue_bonus"
          class="course-result-table__col"
        >
          <v-card outlined>
            <div class="c-result-font-roboto--500 c-result-dialog-card confirm-dates">
              <li
                v-for="(otherPoint) in otherPointList" :key="otherPoint.name"
                class="course-result-table__col"
              >
                <v-row
                  no-gutters
                  class="justify-space-between"
                >
                  <v-col
                    cols="12"
                    class="confirm-dates__col--details"
                  >
                    <p class="confirm-dates__title ma-0 font-weight-bold">{{ otherPoint.name }}</p>
                    <table class="confirm-dates__table c-custom--w-100">
                      <tr>
                        <th class="text-left">ポイント</th>
                        <td class="text-right"><span>{{ otherPoint.point }}</span>pt</td>
                      </tr>
                    </table>
                    <div class="pt-4 text-right">
                      <v-btn
                        @click="openPDF(otherPoint.manual)"
                        rounded
                        class="c-result-btn--gray c-result-btn--gray--modal confirm-dates-result-btn--gray font-weight-bold"
                      >
                        獲得方法
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </li>
            </div>
          </v-card>
        </li>
      </ul>
    </div>

    <!-- コース説明のダイアログ -->
    <v-dialog
      v-model="courseInfoDialog"
      scrollable
      :max-width="350"
      class="c-custom--v-dialog"
    >
      <v-card>
        <v-toolbar
          flat
          dense
          class="d-flex flex-row-reverse"
        >
          <v-btn
            fab
            small
            @click="courseInfoDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <CourseDetailCard :course="selectedCourse"/>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row class="">
    </v-row>

    <!-- <v-row v-if="showAppStatusInfo">
      <v-col cols="12" style="margin:auto">
        <AppStatus :appStatus="appEntryStatus"/>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
// import GraphqlAPI from '../../utils/GraphqlAPI'
import dayjs from 'dayjs'
const CourseDetailCard = () => import('../course/CourseDetailCard')
const LineChart = () => import('./LineChart')
// const AppStatus = () => import('../app/AppStatus')

export default {
  name: 'ResultTopicConfirm',
  data () {
    return {
      listClass: '',
      courseResultList: [],
      otherPointList: [],
      selectedCourse: {},
      chartDataSetList: [],
      rankingList: [],
      dialog: false,
      courseResultHeaders: [
        { text: '選択コース', value: 'name', sortable: false, class: 'pl-2 pr-1' },
        { text: 'コースの説明', value: 'detail', sortable: false, class: 'pl-2 pr-1' },
        { text: 'コース達成状況', value: 'clear_text', sortable: false, class: 'pl-2 pr-1' },
        { text: 'ポイント', value: 'point', sortable: false, class: 'pl-2 pr-1' },
        { text: '平均', value: 'average', sortable: false, class: 'pl-2 pr-1' },
        { text: '累計', value: 'total', sortable: false, class: 'pl-2 pr-1' }
      ],
      showAppStatusInfo: false,
      isViewLoading: false,
      courseInfoDialog: false // コース説明のダイアログ
    }
  },
  props: [
    'campaignUser',
    'propsDailyValueList'
  ],
  components: {
    CourseDetailCard,
    LineChart
    // AppStatus
  },
  computed: {
    isContinuity () {
      return this.campaign.is_continuity
    },
    isCampaignStarted () {
      return new Date(this.campaign.start) <= new Date()
    },
    remainingDaysByNomalCampaignEnd () { // 通常版記録終了日までの残日数計算
      const today = new Date()
      const campaignEndDate = new Date(this.campaign.end)
      return Math.ceil((campaignEndDate - today) / 86400000) + 1
    },
    remainingDaysByNomalSiteClose () { // 通常版サイトクローズ日までの残日数計算
      const today = new Date()
      const siteCloseDate = new Date(this.campaign.site_close)
      return Math.ceil((siteCloseDate - today) / 86400000) + 1
    },
    remainingDaysByContinueSiteClose () { // 継続版サイトクローズ日までの残日数計算
      const today = new Date()
      const siteCloseDateForNormal = new Date(this.getRelationalCampaign.site_close)
      const siteCloseDateForContinue = new Date(this.campaign.site_close)
      if (this.isContinuity) {
        return Math.ceil((siteCloseDateForContinue - today) / 86400000) + 1
      } else {
        return Math.ceil((siteCloseDateForNormal - today) / 86400000) + 1
      }
    },
    campaign () {
      return this.$store.getters.getCampaign
    },
    getRelationalCampaign () {
      return this.$store.getters.getRelationalCampaign
    },
    chartStyle () {
      return {
        height: `${this.height}px`,
        position: 'relative'
      }
    },
    appEntryStatus () {
      return this.$store.getters.getAppEntryStatus
    },
    isMobile () { // モバイル判定
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    }
  },
  watch: {
    propsDailyValueList: {
      handler (newValue) {
        if (newValue !== null) {
          this.listClassSetting(newValue)
          this.courseResultListFormatter(newValue)
          this.chartDataFormatter(newValue)
        }
      },
      deep: true
    }
  },
  async created () {
    if (!this.campaign.id) {
      await this.$store.dispatch('initCampaign')
    }
    if (this.propsDailyValueList !== null) {
      this.listClassSetting(this.propsDailyValueList)
      this.courseResultListFormatter(this.propsDailyValueList)
      this.chartDataFormatter(this.propsDailyValueList)
    }

    /**
     * アプリチャレンジステータス表示するか
     * キャンセルステータスの場合、コース変更可能期間後は、ここには表示しない
     */
    if (this.campaign.is_app_challenge) {
      const courseDeletableEnd = dayjs(this.campaign.course_deletable_end, 'YYYY-MM-DD').add(1, 'days')
      const isCourseChangeablePeriod = dayjs() < courseDeletableEnd
      this.showAppStatusInfo = this.appEntryStatus && this.appEntryStatus !== 'Unregistered' && !(!isCourseChangeablePeriod && this.appEntryStatus === 'Canceled')
    }
  },
  methods: {
    calculateClearRate (course) {
      const clearCount = course.aggregate_result_info.clear_count
      const totalCount = course.complete_value
      return totalCount !== 0 ? Math.floor((clearCount / totalCount) * 100) : 0
    },
    calculateRemainingClearRate (course) {
      const clearRate = this.calculateClearRate(course)
      return 100 - clearRate
    },
    // htmlに適用するclassを設定する
    listClassSetting (resultList) {
      if (resultList.select_course_list.length === 1) {
        this.listClass = 'course-result--one course-result-table__row'
      } else if (resultList.select_course_list.length > 1) {
        this.listClass = 'course-result-table__row'
      }
    },
    // コースごとの達成状況のリストをフォーマットする
    courseResultListFormatter (resultList) {
      this.isViewLoading = true
      this.courseResultList = resultList.select_course_list.map(courseResult => {
        let requiredClear = null
        if (courseResult.complete_type === 'Daily_CircleAndCross' ||
          courseResult.complete_type === 'Daily_StandardValue' ||
          courseResult.complete_type === 'UpperLimit'
        ) { // 残りの必要なクリア日数・週数の定義
          requiredClear = courseResult.complete_value - courseResult.aggregate_result_info.clear_count
        } else if (courseResult.complete_type === 'Weekly_CircleAndCross') {
          requiredClear = courseResult.complete_value - courseResult.aggregate_result_info.clear_count
        }
        return {
          ...courseResult,
          required_clear: requiredClear,
          point: courseResult.aggregate_result_info.point ? courseResult.aggregate_result_info.point : 0
        }
      })
      this.otherPointList = [
        {
          name: this.campaignUser.other_point_list[0] ? this.campaignUser.other_point_list[0].name : 'クローバーマークによる獲得ポイント',
          manual: 'continue_bonus_detail',
          point: this.campaignUser.other_point_list[0] ? this.campaignUser.other_point_list[0].point : 0
        }
      ]
      this.isViewLoading = false
    },
    // グラフ出力対象コースのデータをフォーマットする
    chartDataFormatter (resultList) {
      this.chartDataSetList = []
      const displayChartCourse = resultList.select_course_list.filter(courseResult => {
        return courseResult.is_display_graph
      })
      displayChartCourse.forEach(targetCourse => {
        const dates = []
        const values = []
        resultList.daily_results.forEach(dailyResult => {
          const splitDate = dailyResult.meta.split('-')
          dates.push(splitDate[1] + '/' + splitDate[2])
          let hasTargetData = false
          dailyResult.select_course_result.forEach(courseResult => {
            if (courseResult.course_id === targetCourse.id) {
              hasTargetData = true
              // 「0」が入力されたデータはプロット対象外とする
              if (targetCourse.result_type === 'Number') {
                values.push((courseResult.number === 0) ? null : courseResult.number)
              } else if (targetCourse.result_type === 'Integer') {
                values.push((courseResult.integer === 0) ? null : courseResult.integer)
              }
            }
          })
          if (!hasTargetData) {
            values.push(null)
          }
        })
        // Chart.jsで出力
        this.chartDataSetList.push({
          courseId: targetCourse.id,
          chartData: {
            labels: dates,
            datasets: [
              {
                label: targetCourse.name,
                backgroundColor: '#ff6673',
                data: values,
                spanGaps: true
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    userCallback: function (tick) {
                      // 整数入力時（小数点切捨て）
                      if (targetCourse.result_type === 'Integer') {
                        if (Math.floor(tick) === tick) {
                          return tick.toString() + targetCourse.unit
                        }
                      // 数値入力時（小数点第2位以下切捨て）
                      } else if (targetCourse.result_type === 'Number') {
                        if ((Math.floor(tick * 10)) / 10 === tick) {
                          return tick.toString() + targetCourse.unit
                        }
                      }
                    }
                  }
                }
              ]
            }
          }
        })
      })
    },
    openModal (courseResult) {
      this.selectedCourse = courseResult
      this.courseInfoDialog = true
    },
    openPDF (target) {
      window.open('/manual/' + target + '.pdf', '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
/* v-btn 上書き */
.v-btn:not(.v-btn--round).v-size--default {
  &.confirm-dates-result-btn--gray {
    height: calc(36 / 390 * 100vw);
    @media screen and (min-width: 960px) {
      height: 36px;
    }
  }
}

/* 達成状況確認 */
.course-result-table {
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .course-result-table__row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
    grid-auto-rows: minmax(auto, auto);
    gap: calc(24 / 390 * 100vw);
    @media screen and (min-width: 960px) {
      grid-template-columns: repeat(auto-fit, minmax(352px, 1fr));
      gap: 40px;
    }

    &.course-result--one {
      // 1つのみの場合\
      display: flex;
      justify-content: center;
      .course-result-table__col {
        width: 100%;
        @media screen and (min-width: 960px) {
          width: min(352px , 80%);
        }
      }
    }

    .course-result-table__col {
    }
  }

  /* 達成状況の箱 */
  .confirm-dates {
    .confirm-dates__col--details {
      padding-left: calc(12 / 390 * 100vw);
      @media screen and (min-width: 960px) {
        padding-left: 12px;
      }
    }
    .confirm-dates-days {
      position: relative;
      @media screen and (min-width: 960px) {
      }

      .confirm-dates-days__text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: calc(68 / 390 * 100vw);
        font-size: calc(14 / 390 * 100vw);
        @media screen and (min-width: 960px) {
          height: auto;
          font-size: 14px;
        }

        .is-days-now {
          font-size: calc(38 / 390 * 100vw);
          font-weight: bold;
          line-height: 1;
          background: linear-gradient(180deg, #73D0FF 30%, #139BDF 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          @media screen and (min-width: 960px) {
            font-size: 38px;
            line-height: 1.375rem;
          }
        }
      }

      .is-clear {
        position: absolute;
        top: 0;
        left: 0;
        width: calc(20 / 390 * 100vw);
        min-width: calc(33 / 390 * 100vw);
        height: auto;
        @media screen and (min-width: 960px) {
          width: 20%;
          min-width: 37px;
        }

        img {
          width: 100%;
        }
      }
    }

    .confirm-dates-rest {
      gap: calc(10 / 390 * 100vw);
      height: calc(52 / 390 * 100vw);
      font-size: calc(14 / 390 * 100vw);
      border-radius: calc(4 / 390 * 100vw);
      background-color: #FFFDE1;
      @media screen and (min-width: 960px) {
        gap: 10px;
        height: auto;
        font-size: 0.875rem;
        border-radius: 4px;
      }

      .is-days-rest {
        font-size: calc(24 / 390 * 100vw);
        @media screen and (min-width: 960px) {
          font-size: 24px;
        }
      }
    }

    .confirm-dates__title {
      height: auto;
      padding-bottom: calc(12 / 390 * 100vw);
      font-size: calc(18 / 390 * 100vw);
      line-height: 1.2;
      @media screen and (min-width: 960px) {
        height: auto;
        padding-bottom: 12px;
        font-size: 18px;
        line-height: 1.3;
      }
    }

    .confirm-dates__table {
      font-size: calc(16 / 390 * 100vw);
      line-height: 1.3;
      @media screen and (min-width: 960px) {
        font-size: 16px;
        line-height: 1.375rem;
      }
      th {
        font-weight: normal;
      }

      td {
        font-size: 1.125em;
      }
    }
  }
}

/* キャンペーン終了まであと◯日 */
.course-result-table__rest {
  border-radius: 4px;
  border: 2px solid #19ADF8;
  background: #fff ;
  @media screen and (max-width: 959px) {
  /* sp */
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(52 / 390 * 100vw);
    font-size: calc(14 / 390 * 100vw);
  }

  .is-days-rest {
    font-size: 1.6em;
    @media screen and (max-width: 959px) {
    /* sp */
      padding-bottom: calc(4 / 390 * 100vw);
      font-size: calc(24 / 390 * 100vw);
    }
  }
}

/* 初期 */
.rank-icon {
  margin: 7px 12px !important;
}
.course-result-table > .v-data-table ::v-deep th {
  border-right: 1px solid #c4c4c4 !important;
  background-color: #FFF8E1 !important;
  text-align: center !important;
}
.course-result-table > .v-data-table ::v-deep td {
  padding-left: 8px !important;
  padding-right: 4px !important;
  font-size: 0.8rem !important;
  border-right: 1px solid #c4c4c4 !important;
}
.course-result-table > .v-data-table ::v-deep div.v-data-table__wrapper {
  border: 1px solid #c4c4c4 !important;
  border-right: 0px !important;
}
</style>
